import { render, staticRenderFns } from "./MapIconKozlovForest.vue?vue&type=template&id=3e073602&scoped=true&"
import script from "./MapIconKozlovForest.vue?vue&type=script&lang=js&"
export * from "./MapIconKozlovForest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e073602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e073602')) {
      api.createRecord('3e073602', component.options)
    } else {
      api.reload('3e073602', component.options)
    }
    module.hot.accept("./MapIconKozlovForest.vue?vue&type=template&id=3e073602&scoped=true&", function () {
      api.rerender('3e073602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconKozlovForest.vue"
export default component.exports